import type { NotificationTheme } from '~/shared/lib/notifications'
import type { IconName } from '~/shared/ui/Icon'
import type { IconButtonSize } from '~/shared/ui/IconButton'

/**
 * Подпись крестика для скринридера. Живёт здесь, а не в modules/lunya/copy: shared/ui —
 * нижний слой и про домен не знает (как «Шторка» у BottomSheet). Видимого текста нет.
 */
export const NOTIFICATION_CLOSE_LABEL = 'Закрыть уведомление'

/** Иконка бейджа уведомления по типу (ERROR/WARNING/SUCCESS/INFO). */
export const NOTIFICATION_THEME_ICON: Record<NotificationTheme, IconName> = {
  ERROR: 'alert',
  WARNING: 'warning',
  SUCCESS: 'check',
  INFO: 'info',
}

/** Иконка в круглом бейдже. */
export const NOTIFICATION_BADGE_ICON_SIZE = 16

/**
 * Крестик: кнопка ровно в минимальный тап-таргет (44px), а глиф крупнее табличного.
 * Раньше стоял размер `L` — глиф был тот же 20px, но коробка 52px и задирала высоту строки.
 * Основатель просил одновременно и строку ниже, и крестик заметнее — это возможно только
 * если развести размер кнопки и размер иконки.
 */
export const NOTIFICATION_CLOSE_SIZE: IconButtonSize = 'M'
export const NOTIFICATION_CLOSE_ICON_SIZE = 24
